import React from 'react';
import classnames from 'classnames';
import s from './FeedContent.scss';
const FeedContent = ({ children , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, children);
FeedContent.displayName = 'FeedContent';
export default FeedContent;
